<template>
  <div class="w-full">
      <cabecera-web></cabecera-web>
      <pantalla-final></pantalla-final>
  </div>  
</template>
<script>
import PantallaFinal from '@/components/Final'
import CabeceraWeb from "@/components/Cabecera"
export default {
  components: {
    PantallaFinal,
    CabeceraWeb
  }
}
</script>